<template>
    <div class="main" @click="choose(-1)">
        <div class="select-container animate__animated animate__slideInUp">
        <p>{{store.params[index].name}}</p>
        <p class="h2 description-label" >{{store.params[index].unit}}</p>
        <div class="option-container">
            <ParamSelectButton
                v-for="(value, vindex) in store.params[index].values"
                :label="value.value" :row="vindex+2" :key="vindex" :mod="value.mod"
                @click="choose(vindex)" />
        </div>
        </div>
    </div>
</template>

<script>
    import ParamSelectButton from "./ParamSelectButton"
    import store from "../assets/store"

    export default {
        components: {
            ParamSelectButton
        },
        props: ["index"],
        data() {
            return {
                store: store
            }
        },
        mounted: function (){
             document.querySelector('.select-container').style.setProperty('--animate-duration', '0.2s');
        },
        methods: {
            choose(vindex) {
                if(vindex >= 0) {
                    this.store.params[this.index].chosen = vindex
                }
                document.querySelector('.select-container').classList.remove('animate__slideInUp')
                document.querySelector('.select-container').classList.add('animate__slideOutDown')
                document.querySelector('.select-container').addEventListener('animationend', () => {
                    this.$emit('chosed')
                })

            }
        }
    };
</script>

<style>
.main {
        position: fixed;
    top: 0;
    left: 0;
    z-index: 25;
    height: 100vh;
    width: 100vw;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(2px);
    /* padding-top: 400px; */
    overflow: scroll;
}

.select-container {
    position: relative;
    width: 100vw;
    background-color: #f2f2f2;
    box-shadow: 0px -26px 90px 20px rgba(0,0,0,0.75);
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    margin-top: 60vh;
    min-height: 40vh;
    padding-top: 20px;
    padding-bottom: 20px;
}
</style>